import React, { useState } from 'react';
import AddTaskCommentView from '../view/AddTaskCommentView';
import fetchAPI from '../../../utils/fetchAPI';

const AddTaskCommentEngine = ({ isEndUser, onAddedComment = () => {}, taskId }) => {
  const [comment, setComment] = useState('');
  const commentUrl = `/tasks/v1/${isEndUser ? 'eu/' : ''}tasks/comment`;
  const clickedSend = () => {
    fetchAPI(commentUrl, {
      body: {
        body: comment,
        entityId: taskId
      },
      method: 'POST'
    }).then(res => {
      onAddedComment();
    openSnackbar('success', 'snackbars.tasks.comment_success');
  }).catch(() => {
    openSnackbar('warning', 'snackbars.tasks.comment_failure');
  });
  };
  const viewProps = {
    clickedSend,
    comment,
    setComment
  };

  return <AddTaskCommentView {...viewProps} />;
};

export default AddTaskCommentEngine;
